export default __webpack_public_path__ + "static/media/executive-leaders.aada6772.webp";